import { WorkspaceList } from "@/components/UI/TableToolbar/WorkspaceButton/workspace";

// Single-subject pages are named "<dataset>-ssj" or "<dataset>-<subjectId>".
// Subject ids are upper-case/numeric, so the trailing-id pattern is matched
// case-SENSITIVELY. With the /i flag it also matched ordinary lower-case
// suffixes, so every hyphenated table name ("portfolio-investigators",
// "portfolio-sites", "portfolio-trials") was treated as single-subject.
export function isSingleSubjectPage(pageName: string): boolean {
  return (
    pageName.includes("-ssj") ||
    /-[A-Z0-9][A-Z0-9\-_]*$/.exec(pageName) !== null
  );
}

export function sortWorkspaces(workspaces?: WorkspaceList): WorkspaceList {
  if (!workspaces || workspaces.length === 0) return [];

  return [...workspaces].sort((a, b) => {
    if (a.is_vivo_template && !b.is_vivo_template) return -1;
    if (!a.is_vivo_template && b.is_vivo_template) return 1;

    if (a.is_vivo_template && b.is_vivo_template) {
      return a.title.localeCompare(b.title);
    }

    return (
      new Date(b.modified_at).getTime() - new Date(a.modified_at).getTime()
    );
  });
}
